// !! ------
//  This section is completely optionial
//  Don want to use it? then rip it out
// !! ------

export const getPageUrlById = (id) => {
  return PAGES[id]?.base_url || '';
};

export const getPageIdByUrl = (url) => {
  for (const key in ALL_URLS) {
    if (ALL_URLS.hasOwnProperty.call(ALL_URLS, key)) {
      const element = ALL_URLS[key];

      if (element.includes(url)) {
        return key;
      }
    }
  }
};

export const PAGE_IDS = {
  home: 'homepage',
  library: 'library',
  collections: 'collections',
  find: 'find',
  results: 'results',
  cards: 'cards',
  favorites: 'favorites',
  recent: 'recent',
  all: 'all',
};

export const METADATA_CMS_IDS = {
  [PAGE_IDS.home]: 'homepage',
  [PAGE_IDS.library]: 'library_page',
  [PAGE_IDS.collections]: 'collections_page',
  [PAGE_IDS.find]: 'find_page',
  [PAGE_IDS.results]: 'results_page',
  [PAGE_IDS.favorites]: 'favorites_page',
  [PAGE_IDS.cards]: 'card_page',
  [PAGE_IDS.recent]: 'recent_page',
  [PAGE_IDS.all]: 'all_cards_page',
};

export const ALL_URLS = {
  [PAGE_IDS.home]: '/',
  [PAGE_IDS.library]: '/library',
  [PAGE_IDS.collections]: '/collections',
  [PAGE_IDS.find]: '/find',
  [PAGE_IDS.results]: '/find/results',
  [PAGE_IDS.favorites]: '/favorites',
  [PAGE_IDS.cards]: '/card',
  [PAGE_IDS.recent]: '/recent',
  [PAGE_IDS.all]: '/all-cards',
};

export const PAGES = {
  [PAGE_IDS.home]: {
    id: PAGE_IDS.home,
    name: 'Home',
    base_url: ALL_URLS[PAGE_IDS.home],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.home],
    },
  },
  [PAGE_IDS.library]: {
    id: PAGE_IDS.library,
    name: 'Library',
    base_url: ALL_URLS[PAGE_IDS.library],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.library],
    },
  },
  [PAGE_IDS.collections]: {
    id: PAGE_IDS.collections,
    name: 'Collections',
    base_url: ALL_URLS[PAGE_IDS.collections],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.collections],
    },
  },
  [PAGE_IDS.favorites]: {
    id: PAGE_IDS.favorites,
    name: 'Favorites',
    base_url: ALL_URLS[PAGE_IDS.favorites],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.favorites],
    },
  },
  [PAGE_IDS.card]: {
    id: PAGE_IDS.cards,
    name: 'Card',
    base_url: ALL_URLS[PAGE_IDS.cards],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.cards],
    },
  },
  [PAGE_IDS.recent]: {
    id: PAGE_IDS.recent,
    name: 'Recent',
    base_url: ALL_URLS[PAGE_IDS.recent],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.recent],
    },
  },
  [PAGE_IDS.all]: {
    id: PAGE_IDS.all,
    name: 'All Cards',
    base_url: ALL_URLS[PAGE_IDS.all],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.all],
    },
  },
  [PAGE_IDS.find]: {
    id: PAGE_IDS.find,
    name: 'Find',
    base_url: ALL_URLS[PAGE_IDS.find],
    metadata: {
      landing: METADATA_CMS_IDS[PAGE_IDS.find],
    },
    stack: {
      [PAGE_IDS.results]: {
        id: PAGE_IDS.results,
        name: 'Results',
        base_url: ALL_URLS[PAGE_IDS.results],
        stack_url: `results`,
        metadata: {
          landing: METADATA_CMS_IDS[PAGE_IDS.results],
        },
      },
    },
  },
};

export const PRIVATE_PAGES = {};
export const URL_PAGE_HOME = '/';
